import React from "react";
import { RelevantTenantInfo } from "routes/Admin/Accounts/Members/Helpers";
import { TenantType } from "generated/graphql.schema";
import UserTable from "routes/Admin/Accounts/Members/UserTable";
import { InternalRoleNames } from "roles";
import { Layout } from "views/Main/Layouts";
import { usePolyAdmin } from "rbac";
import { LocalKeys } from "utilities/i18n";

const labels = {
  userColumnHeader: "USER_NAME" as LocalKeys,
  deleteDialogTitle: "DELETE_POLY_INTERNAL_USER" as LocalKeys,
  deleteDialogContent: "CONFIRM_DELETE_POLY_INTERNAL_USER" as LocalKeys,
  deleteDialogConfirm: "DELETE" as LocalKeys,
  deleteDialogSuccess: "SUCCESSFULLY_DELETED_INTERNAL_USERS" as LocalKeys
};

const PolyUsersTableView: React.FC<{}> = () => {
  const tenant: RelevantTenantInfo = {
    id: "*",
    name: "All Tenants",
    type: TenantType.Enterprise // this is normally used to get the default role value in the drop down
  };
  const tags = ["poly-internal"];
  const isPolyAdmin = usePolyAdmin();

  return (
    <div className="account-table-content">
      <Layout>
        <UserTable
          tenant={tenant}
          roles={InternalRoleNames}
          tags={tags}
          editingAllowed={isPolyAdmin}
          labels={labels}
        />
      </Layout>
    </div>
  );
};

export default PolyUsersTableView;
